export default __webpack_public_path__ + "static/regularfile-56af0d3a8cf19bcbb254fd0165ee8c6d.png";